const getBufferFrom = value => Buffer.from(value, 'binary').toString('base64');
export default getBufferFrom;
